import React from 'react';
import PropTypes from 'prop-types';
import BottomSheet from './bottom-sheet';
import Spacer from '../spacer';
import Text from '../text';
import Colors from '../colors';
export default function AppPicker(props) {
  /*#__PURE__*/
  React.createElement(BottomSheet, null, /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.gray300
  }, props.header), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), props.children);
}
AppPicker.defaultProps = {
  header: 'Choose Source',
  children: ''
};
AppPicker.propTypes = {
  header: PropTypes.string,
  children: PropTypes.node
};
//# sourceMappingURL=app-picker.js.map